import { styled } from '@mui/material';
import Box from 'shell/components/Box';

const CustomBox = styled(Box)(({ direction, theme }) => {
    return {
        flex: 1,
        ...(direction === 'column' && {
            paddingTop: theme.spacing(2),
        }),
    };
});

const TabPanel = ({ children, direction, $key, selected, keepMounted = false }) => {
    return (
        <CustomBox
            id={`tabpanel-${$key}`}
            aria-labelledby={`tab-${$key}`}
            direction={direction}
            hidden={$key !== selected}
            role={'tabpanel'}
        >
            {(keepMounted || $key === selected) && children}
        </CustomBox>
    );
};

export default TabPanel;
